// ----------------------------------------------------------------------

export default function Paper(theme) {
  return {
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          borderRadius: '16px'
        },
        silver:{
          padding: '4px',
          borderRadius: '4px',
          background: 'rgba(255, 255, 255, 0.38)',
          boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
          backdropFilter: 'blur(5px)',
          WebkitBackdropFilter: 'blur(5px)',
          borderColor: "rgba(255, 255, 255, 0.3)"
        },
        gold:{
          padding: '4px',
          borderRadius: '4px',
          background: 'rgba(255, 215, 0, 0.34)',
          boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
          backdropFilter: 'blur(5px)',
          WebkitBackdropFilter: 'blur(5px)',
          borderColor: "rgba(255, 215, 0, 0.3)"
        }
      },
    },
  };
}
